module.exports = "/images/trialproofer-app-image@3x.png?b018552d32e3dadf119ceb52f856d49f";